import { ButtonAdd } from "@neonumy/ant-design";
import { Card, Col, Form, Modal, Row } from "antd";
import { FaSave, FaMoneyBillWave } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import useProductModal from "../hooks/useProductModal";
import useProductFormData from "../hooks/useProductFormData";
import ProductFormFields from "./Forms/ProductFormFields";
import ProductPricesFormList from "./Forms/ProductPricesFormList";
import CreateCategoryDrawer from "./CreateCategory";
import CardTitle from "components/CardTitle";

interface CreateProductProps {
  loading: boolean;
  refetch: () => void;
}

export default function CreateProduct({ refetch }: CreateProductProps): React.ReactElement {
  const { t } = useTranslation();

  const { form, isOpen, showModal, handleOk, handleCancel, onFinish } = useProductModal({
    onSuccess: refetch,
  });

  const {
    categoryOptions,
    operationsCategories,
    hasDeclareTva,
    counterpartByCategory,
    refetchCategories,
    onValuesChange,
  } = useProductFormData({ form, isOpen });

  return (
    <>
      <Row justify="end" className="margin-top">
        <ButtonAdd onClick={showModal}>{t("Add")}</ButtonAdd>
      </Row>
      <Modal
        title={t("New product")}
        open={isOpen}
        onOk={handleOk}
        okText={t("Save")}
        okButtonProps={{
          icon: (
            <span className="anticon">
              <FaSave />
            </span>
          ),
        }}
        onCancel={handleCancel}
        width={"50%"}
        className="antd-modal"
      >
        <Form
          name="createProduct"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          onValuesChange={onValuesChange}
          autoComplete="off"
        >
          <Row gutter={[16, 16]}>
            <ProductFormFields
              categoryOptions={categoryOptions}
              operationsCategories={operationsCategories}
              hasDeclareTva={hasDeclareTva}
              counterpartByCategory={counterpartByCategory}
              extraCategoryAction={<CreateCategoryDrawer refetchCategories={refetchCategories} />}
            />
            <Col span={24}>
              <Card
                size="small"
                title={<CardTitle icon={<FaMoneyBillWave />} title={t("Prices by currency")} />}
                className="antd-newrai-card"
                headStyle={{ borderBottom: "1px solid #f0f0f0" }}
              >
                <ProductPricesFormList isOpen={isOpen} />
              </Card>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
